import { useRef } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

export default function TiltedCard({
  children,
  className = '',
  rotateAmplitude = 9,
  scaleOnHover = 1.02,
}) {
  const ref = useRef(null);
  const rotateX = useSpring(useMotionValue(0), { stiffness: 300, damping: 30 });
  const rotateY = useSpring(useMotionValue(0), { stiffness: 300, damping: 30 });
  const scale = useSpring(1, { stiffness: 300, damping: 30 });

  const supported = () =>
    typeof matchMedia !== 'undefined' &&
    matchMedia('(hover: hover)').matches &&
    !matchMedia('(prefers-reduced-motion: reduce)').matches;

  const handleMouse = (e) => {
    const el = ref.current;
    if (!el || !supported()) return;
    const rect = el.getBoundingClientRect();
    const offsetX = e.clientX - rect.left - rect.width / 2;
    const offsetY = e.clientY - rect.top - rect.height / 2;
    rotateX.set((-offsetY / (rect.height / 2)) * rotateAmplitude);
    rotateY.set((offsetX / (rect.width / 2)) * rotateAmplitude);
  };

  const handleEnter = () => scale.set(scaleOnHover);
  const handleLeave = () => {
    scale.set(1);
    rotateX.set(0);
    rotateY.set(0);
  };

  return (
    <motion.div
      ref={ref}
      className={`rb-tilted ${className}`}
      onMouseMove={handleMouse}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      style={{ rotateX, rotateY, scale, transformStyle: 'preserve-3d', transformPerspective: 900 }}
    >
      {children}
    </motion.div>
  );
}
